import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import Loading from "../components/Loading";
import ViewFormInput from "../components/ViewFormInput";
import ViewFormTextArea from "../components/ViewFormTextArea";
import ViewFormCheckboxGroup from "../components/ViewFormCheckboxGroup";
import ViewFormRadioGroup from "./../components/ViewFormRadioGroup";
import ViewFromFileUpload from "../components/ViewFromFileUpload";

import { getForm, submitResponse } from "../utils/backend"; //, saveResponse
import { nameToKey, isResponseInvalid } from "./../utils/helpers";

const ViewForm = () => {
  const history = useHistory();

  const formId = history.location.pathname.split("/").pop();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formTitle, setFormTitle] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const fetchForm = async (formId) => {
      try {
        const form = await getForm(formId);

        setFormTitle(form.title);
        setFormDescription(form.description);

        const quesWithAnswer = form.questions.map((ques) => ({
          ...ques,
          answer: ques.questionType === "checkbox" ? [] : "",
        }));

        setQuestions(quesWithAnswer);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("an error occurred ", error);
        toast.error(
          "Something went wrong! Please check the form id in URL or try again later"
        );
        history.replace("/");
      }
    };

    setLoading(true);
    fetchForm(formId);
  }, [formId, history]);

  const setAnswer = (index, answer) => {
    const updatedQues = [...questions];
    updatedQues[index].answer =
      updatedQues[index].questionType === "number"
        ? parseFloat(answer)
        : answer;
    setQuestions(updatedQues);
  };

  const submitForm = async () => {
    setSaving(true);

    if (isResponseInvalid(questions)) {
      setSaving(false);
      toast.info("Form is incomplete");
      return;
    }

    const data = {};
    let attachmentQuestion = null;

    questions.forEach((question) => {
      // convert eache question title to key
      data[nameToKey(question.questionTitle)] = question.answer;

      // check if there is a attachment question
      if (question.questionType === "attachment") {
        attachmentQuestion = question.questionTitle;
      }
    });

    data["attachmentQuestion"] = attachmentQuestion;

    try {
      await submitResponse(formId, data);
      setSaving(false);
      toast.success("Response submitted successfully");
      history.replace("/");
    } catch (error) {
      setSaving(false);
      console.error("an error occurred ", error);
      toast.error("Something went wrong: " + error.response.data);
    }
  };

  if (loading) return <Loading />;

  return (
    <form className="container my-4 col-11 col-md-9">
      <h1 className="mb-3">{formTitle}</h1>
      <h3 className="mb-3 pb-2 border-bottom border-dark">{formDescription}</h3>
      {questions.map(
        (
          { questionTitle: title, questionType: type, answer, ...options },
          index
        ) => {
          const props = {
            key: index,
            index,
            title,
            answer,
            setAnswer,
          };

          switch (type) {
            case "text":
              return <ViewFormInput {...props} type="text" />;

            case "number":
              return <ViewFormInput {...props} type="number" />;

            case "paragraph":
              return <ViewFormTextArea {...props} />;

            case "checkbox":
              return <ViewFormCheckboxGroup {...props} {...options} />;

            case "radioButton":
              return <ViewFormRadioGroup {...props} {...options} />;

            case "attachment":
              return <ViewFromFileUpload {...props} type="file" />;

            default:
              return null;
          }
        }
      )}

      <div
        className="btn btn-success btn-block col-10 mt-4 mx-auto px-1 py-2"
        onClick={submitForm}
      >
        {saving ? "Saving. Please Wait ..." : "Save Form"}
      </div>
    </form>
  );
};

export default ViewForm;
